/*
 * @message:
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-09 15:06:37
 * @FilePath: \mrc-ess-fronted\src\router\router_admin.js
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-29 11:13:06
 */
// Page
// Dashboard
// import Dashboard from "@/Page/EssAdmin/Dashboard/Dashboard";
//Approval
import Approval from "@/Page/EssAdmin/Approval/Approval/Approval";
import editApproval from "@/Page/EssAdmin/Approval/Approval/editApproval";
import viewApproval from "@/Page/EssAdmin/Approval/Approval/viewApproval";
import newApproval from "@/Page/EssAdmin/Approval/Approval/newApproval";
import ApprovalType from "@/Page/EssAdmin/Approval/ApprovalType/ApprovalType";
import newApprovalType from "@/Page/EssAdmin/Approval/ApprovalType/newApprovalType";
import editApprovalType from "@/Page/EssAdmin/Approval/ApprovalType/editApprovalType";
import viewApprovalType from "@/Page/EssAdmin/Approval/ApprovalType/viewApprovalType";
import ApprovalProcess from "@/Page/EssAdmin/Approval/ApprovalProcess/ApprovalProcess";
import viewAttendanceApprovalProcess from "@/Page/EssAdmin/Approval/ApprovalProcess/viewAttendanceApprovalProcess";
import viewRosterApprovalProcess from "@/Page/EssAdmin/Approval/ApprovalProcess/viewRosterApprovalProcess";
import viewAbnormalClockinApprovalProcess from "@/Page/EssAdmin/Approval/ApprovalProcess/viewAbnormalClockinApprovalProcess";
import viewLeaveApprovalProcess from "@/Page/EssAdmin/Approval/ApprovalProcess/viewLeaveApprovalProcess";
import viewCustomFormApprovalProcess from "@/Page/EssAdmin/Approval/ApprovalProcess/viewCustomFormApprovalProcess";
import viewClaimApprovalProcess from "@/Page/EssAdmin/Approval/ApprovalProcess/viewClaimApprovalProcess";
import MessageConfig from "@/Page/EssAdmin/Approval/MessageConfig/MessageConfig";

// Attendance
// import Attendance from "@/Page/EssAdmin/Attendance/Attendance";
// import editAttendance from "@/Page/EssAdmin/Attendance/editAttendance";
// import newAttendance from "@/Page/EssAdmin/Attendance/newAttendance";
import AttendanceRecord from "@/Page/EssAdmin/Attendance/AttendanceRecord/AttendanceRecord";
import AttendanceRecordDetail from "@/Page/EssAdmin/Attendance/AttendanceRecord/viewAttendanceRecord";
import AttendanceRecordModiApp from "@/Page/EssAdmin/Attendance/AttendanceRecordModiApp/AttendanceRecordModiApp";
import viewAttendanceRecordModiApp from "@/Page/EssAdmin/Attendance/AttendanceRecordModiApp/viewAttendanceRecordModiApp";
import AttendanceModiReason from "@/Page/EssAdmin/Attendance/AttendanceModiReason/AttendanceModiReason";
import newAttendanceModiReason from "@/Page/EssAdmin/Attendance/AttendanceModiReason/newAttendanceModiReason";
import editAttendanceModiReason from "@/Page/EssAdmin/Attendance/AttendanceModiReason/editAttendanceModiReason";
import viewAttendanceModiReason from "@/Page/EssAdmin/Attendance/AttendanceModiReason/viewAttendanceModiReason";
import InternalUse from "@/Page/EssAdmin/Attendance/InternalUse/Attendance";
import LeaveApplication_InteralUse from "@/Page/EssAdmin/Attendance/InternalUse/LeaveApplication/leaveApplication";
import viewLeaveApplication_InteralUse from "@/Page/EssAdmin/Attendance/InternalUse/LeaveApplication/ViewLeaveApplication";
import addLeaveApplication_InteralUse from "@/Page/EssAdmin/Attendance/InternalUse/LeaveApplication/newLeaveApplication";
import editInternalUse from "@/Page/EssAdmin/Attendance/InternalUse/editAttendance";
import StaffCard from "@/Page/EssAdmin/Attendance/StaffCard/StaffCard";

// Claim
import ClaimReason from "@/Page/EssAdmin/Claim/ClaimReason/ClaimReason";
import newClaimReason from "@/Page/EssAdmin/Claim/ClaimReason/newClaimReason";
import editClaimReason from "@/Page/EssAdmin/Claim/ClaimReason/editClaimReason";
import viewClaimReason from "@/Page/EssAdmin/Claim/ClaimReason/viewClaimReason";
import ClaimBalance from "@/Page/EssAdmin/Claim/ClaimBalance/ClaimBalance";
import viewClaimBalance from "@/Page/EssAdmin/Claim/ClaimBalance/viewClaimBalance";
import ClaimRecord from "@/Page/EssAdmin/Claim/ClaimRecord/ClaimRecord";
import ClaimRecordItem from "@/Page/EssAdmin/Claim/ClaimRecord/ClaimRecordItem";
import editClaimRecord from "@/Page/EssAdmin/Claim/ClaimRecord/editClaimRecord";
import ClaimType from "@/Page/EssAdmin/Claim/ClaimType/ClaimType";
import newClaimType from "@/Page/EssAdmin/Claim/ClaimType/newClaimType";
import editClaimType from "@/Page/EssAdmin/Claim/ClaimType/editClaimType";
import viewClaimType from "@/Page/EssAdmin/Claim/ClaimType/viewClaimType";
import ClaimItemType from "@/Page/EssAdmin/Claim/ClaimItemType/ClaimItemType";
import newClaimItemType from "@/Page/EssAdmin/Claim/ClaimItemType/newClaimItemType";
import editClaimItemType from "@/Page/EssAdmin/Claim/ClaimItemType/editClaimItemType";
import viewClaimItemType from "@/Page/EssAdmin/Claim/ClaimItemType/viewClaimItemType";
import ClaimTransactionPropertyGroup from "@/Page/EssAdmin/Claim/ClaimTransactionPropertyGroup/ClaimTransactionPropertyGroup";
import newClaimTransactionPropertyGroup from "@/Page/EssAdmin/Claim/ClaimTransactionPropertyGroup/newClaimTransactionPropertyGroup";
import editClaimTransactionPropertyGroup from "@/Page/EssAdmin/Claim/ClaimTransactionPropertyGroup/editClaimTransactionPropertyGroup";
import viewClaimTransactionPropertyGroup from "@/Page/EssAdmin/Claim/ClaimTransactionPropertyGroup/viewClaimTransactionPropertyGroup";
import ClaimTypePropertyGroup from "@/Page/EssAdmin/Claim/ClaimTypePropertyGroup/ClaimTypePropertyGroup";
import newClaimTypePropertyGroup from "@/Page/EssAdmin/Claim/ClaimTypePropertyGroup/newClaimTypePropertyGroup";
import editClaimTypePropertyGroup from "@/Page/EssAdmin/Claim/ClaimTypePropertyGroup/editClaimTypePropertyGroup";
import viewClaimTypePropertyGroup from "@/Page/EssAdmin/Claim/ClaimTypePropertyGroup/viewClaimTypePropertyGroup";

// Event
import EventList from "@/Page/EssAdmin/Event/EventList/EventList";
import newEvent from "@/Page/EssAdmin/Event/EventList/newEvent";
import editEvent from "@/Page/EssAdmin/Event/EventList/editEvent";
import viewEvent from "@/Page/EssAdmin/Event/EventList/viewEvent";
import EventType from "@/Page/EssAdmin/Event/EventType/EventType";
import newEventType from "@/Page/EssAdmin/Event/EventType/newEventType";
import editEventType from "@/Page/EssAdmin/Event/EventType/editEventType";
import viewEventType from "@/Page/EssAdmin/Event/EventType/viewEventType";
import EventPropertyGroup from "@/Page/EssAdmin/Event/EventPropertyGroup/EventPropertyGroup";
import newEventPropertyGroup from "@/Page/EssAdmin/Event/EventPropertyGroup/newEventPropertyGroup";
import editEventPropertyGroup from "@/Page/EssAdmin/Event/EventPropertyGroup/editEventPropertyGroup";
import viewEventPropertyGroup from "@/Page/EssAdmin/Event/EventPropertyGroup/viewEventPropertyGroup";
// Holiday
import PublicHoliday from "@/Page/EssAdmin/Holiday/PublicHoliday/PublicHoliday";
import newPublicHoliday from "@/Page/EssAdmin/Holiday/PublicHoliday/newPublicHoliday";
import editPublicHoliday from "@/Page/EssAdmin/Holiday/PublicHoliday/editPublicHoliday";
import viewPublicHoliday from "@/Page/EssAdmin/Holiday/PublicHoliday/viewPublicHoliday";
import PublicHolidayGroup from "@/Page/EssAdmin/Holiday/PublicHolidayGroup/PublicHolidayGroup";
import newPublicHolidayGroup from "@/Page/EssAdmin/Holiday/PublicHolidayGroup/newPublicHolidayGroup";
import editPublicHolidayGroup from "@/Page/EssAdmin/Holiday/PublicHolidayGroup/editPublicHolidayGroup";
import viewPublicHolidayGroup from "@/Page/EssAdmin/Holiday/PublicHolidayGroup/viewPublicHolidayGroup";
import HolidayType from "@/Page/EssAdmin/Holiday/HolidayType/HolidayType";
import newHolidayType from "@/Page/EssAdmin/Holiday/HolidayType/newHolidayType";
import editHolidayType from "@/Page/EssAdmin/Holiday/HolidayType/editHolidayType";
import viewHolidayType from "@/Page/EssAdmin/Holiday/HolidayType/viewHolidayType";
// Block Leave
import BlockLeaveGroup from "@/Page/EssAdmin/BlockLeave/BlockLeavePolicy/BlockLeavePolicy";
import newBlockLeaveGroup from "@/Page/EssAdmin/BlockLeave/BlockLeavePolicy/newBlockLeavePolicy";
import editBlockLeaveGroup from "@/Page/EssAdmin/BlockLeave/BlockLeavePolicy/editBlockLeavePolicy";
import viewBlockLeaveGroup from "@/Page/EssAdmin/BlockLeave/BlockLeavePolicy/viewBlockLeavePolicy";
import BlockLeaveRecord from "@/Page/EssAdmin/BlockLeave/BlockLeaveRecord/BlockLeaveRecord";
import BlockLeaveMapping from "@/Page/EssAdmin/BlockLeave/BlockLeaveMapping/BlockLeaveMapping";
// Leave
import LeaveApplication from "@/Page/EssAdmin/Leave/LeaveApplication/LeaveApplication";
import viewLeaveApplication from "@/Page/EssAdmin/Leave/LeaveApplication/viewLeaveApplication";
import LeaveBalance from "@/Page/EssAdmin/Leave/LeaveBalance/LeaveBalance";
import editLeaveBalance from "@/Page/EssAdmin/Leave/LeaveBalance/editLeaveBalance";
import LeaveReason from "@/Page/EssAdmin/Leave/LeaveReason/LeaveReason";
import newLeaveReason from "@/Page/EssAdmin/Leave/LeaveReason/newLeaveReason";
import editLeaveReason from "@/Page/EssAdmin/Leave/LeaveReason/editLeaveReason";
import viewLeaveReason from "@/Page/EssAdmin/Leave/LeaveReason/viewLeaveReason";
import LeaveCanaelReason from "@/Page/EssAdmin/Leave/LeaveCanaelReason/LeaveCanaelReason";
import newLeaveCanaelReason from "@/Page/EssAdmin/Leave/LeaveCanaelReason/newLeaveCanaelReason";
import editLeaveCanaelReason from "@/Page/EssAdmin/Leave/LeaveCanaelReason/editLeaveCanaelReason";
import viewLeaveCanaelReason from "@/Page/EssAdmin/Leave/LeaveCanaelReason/viewLeaveCanaelReason";
import LeaveTransactionPropertyGroup from "@/Page/EssAdmin/Leave/LeaveTransactionPropertyGroup/LeaveTransactionPropertyGroup";
import newLeaveTransactionPropertyGroup from "@/Page/EssAdmin/Leave/LeaveTransactionPropertyGroup/newLeaveTransactionPropertyGroup";
import editLeaveTransactionPropertyGroup from "@/Page/EssAdmin/Leave/LeaveTransactionPropertyGroup/editLeaveTransactionPropertyGroup";
import viewLeaveTransactionPropertyGroup from "@/Page/EssAdmin/Leave/LeaveTransactionPropertyGroup/viewLeaveTransactionPropertyGroup";
import LeaveType from "@/Page/EssAdmin/Leave/LeaveType/LeaveType";
import newLeaveType from "@/Page/EssAdmin/Leave/LeaveType/newLeaveType";
import editLeaveType from "@/Page/EssAdmin/Leave/LeaveType/editLeaveType";
import viewLeaveType from "@/Page/EssAdmin/Leave/LeaveType/viewLeaveType";
import LeaveTypePropertyGroup from "@/Page/EssAdmin/Leave/LeaveTypePropertyGroup/LeaveTypePropertyGroup";
import newLeaveTypePropertyGroup from "@/Page/EssAdmin/Leave/LeaveTypePropertyGroup/newLeaveTypePropertyGroup";
import editLeaveTypePropertyGroup from "@/Page/EssAdmin/Leave/LeaveTypePropertyGroup/editLeaveTypePropertyGroup";
import viewLeaveTypePropertyGroup from "@/Page/EssAdmin/Leave/LeaveTypePropertyGroup/viewLeaveTypePropertyGroup";
// Notification
import MessageType from "@/Page/EssAdmin/Notification/MessageType/MessageType";
// Punch
import PunchCriteriaType from "@/Page/EssAdmin/Punch/PunchCriteriaType/PunchCriteriaType";
import PunchManage from "@/Page/EssAdmin/Punch/PunchManage/PunchManage";
import PunchRecord from "@/Page/EssAdmin/Punch/PunchRecord/PunchRecord";
import AbnormalClockin from "@/Page/EssAdmin/Punch/AbnormalClockin/AbnormalClockin";
import viewAbnormalClockin from "@/Page/EssAdmin/Punch/AbnormalClockin/viewAbnormalClockin";
import AbnormalPunchReason from "@/Page/EssAdmin/Punch/AbnormalPunchReason/AbnormalPunchReason";
import newAbnormalPunchReason from "@/Page/EssAdmin/Punch/AbnormalPunchReason/newAbnormalPunchReason";
import editAbnormalPunchReason from "@/Page/EssAdmin/Punch/AbnormalPunchReason/editAbnormalPunchReason";
import viewAbnormalPunchReason from "@/Page/EssAdmin/Punch/AbnormalPunchReason/viewAbnormalPunchReason";
// Status
import Status from "@/Page/EssAdmin/Status/Status";
//Roster
import RosterForm from "@/Page/EssAdmin/Roster/RosterForm/RosterForm";
import newRosterForm from "@/Page/EssAdmin/Roster/RosterForm/newRosterForm";
import editRosterForm from "@/Page/EssAdmin/Roster/RosterForm/editRosterForm";
import viewRosterForm from "@/Page/EssAdmin/Roster/RosterForm/viewRosterForm";
import RosterPropertyGroup from "@/Page/EssAdmin/Roster/RosterPropertyGroup/RosterPropertyGroup";
import newRosterPropertyGroup from "@/Page/EssAdmin/Roster/RosterPropertyGroup/newRosterPropertyGroup";
import editRosterPropertyGroup from "@/Page/EssAdmin/Roster/RosterPropertyGroup/editRosterPropertyGroup";
import viewRosterPropertyGroup from "@/Page/EssAdmin/Roster/RosterPropertyGroup/viewRosterPropertyGroup";
import RosterRecord from "@/Page/EssAdmin/Roster/RosterRecord/RosterRecord";
import RosterFormRecord from "@/Page/EssAdmin/Roster/RosterFormRecord/RosterFormRecord";
import newRosterFormRecord from "@/Page/EssAdmin/Roster/RosterFormRecord/newRosterFormRecord";
import editRosterFormRecord from "@/Page/EssAdmin/Roster/RosterFormRecord/editRosterFormRecord";
import viewRosterFormRecord from "@/Page/EssAdmin/Roster/RosterFormRecord/viewRosterFormRecord";
import RosterTemplate from "@/Page/EssAdmin/Roster/RosterTemplate/RosterTemplate";
import newRosterTemplate from "@/Page/EssAdmin/Roster/RosterTemplate/newRosterTemplate";
import editRosterTemplate from "@/Page/EssAdmin/Roster/RosterTemplate/editRosterTemplate";
import viewRosterTemplate from "@/Page/EssAdmin/Roster/RosterTemplate/viewRosterTemplate";

// Shift
import ShiftList from "@/Page/EssAdmin/Shift/ShiftList/ShiftList";
import newShiftList from "@/Page/EssAdmin/Shift/ShiftList/newShift";
import editShiftList from "@/Page/EssAdmin/Shift/ShiftList/editShift";
import viewShiftList from "@/Page/EssAdmin/Shift/ShiftList/viewShift";
import ShiftType from "@/Page/EssAdmin/Shift/ShiftType/ShiftType";
import newShiftType from "@/Page/EssAdmin/Shift/ShiftType/newShiftType";
import editShiftType from "@/Page/EssAdmin/Shift/ShiftType/editShiftType";
import viewShiftType from "@/Page/EssAdmin/Shift/ShiftType/viewShiftType";
import ShiftPropertyGroup from "@/Page/EssAdmin/Shift/ShiftPropertyGroup/ShiftPropertyGroup";
import newShiftPropertyGroup from "@/Page/EssAdmin/Shift/ShiftPropertyGroup/newShiftPropertyGroup";
import editShiftPropertyGroup from "@/Page/EssAdmin/Shift/ShiftPropertyGroup/editShiftPropertyGroup";
import viewShiftPropertyGroup from "@/Page/EssAdmin/Shift/ShiftPropertyGroup/viewShiftPropertyGroup";
import ShiftTypeMapping from "@/Page/EssAdmin/Shift/ShiftTypeMapping/ShiftTypeMapping";
// Site
import Site from "@/Page/EssAdmin/Site/SiteList/SiteList";
import newSite from "@/Page/EssAdmin/Site/SiteList/newSite";
import editSite from "@/Page/EssAdmin/Site/SiteList/editSite";
import viewSite from "@/Page/EssAdmin/Site/SiteList/viewSite";
import SiteType from "@/Page/EssAdmin/Site/siteType/siteType";
import newSiteType from "@/Page/EssAdmin/Site/siteType/newSiteType";
import editSiteType from "@/Page/EssAdmin/Site/siteType/editSiteType";
import viewSiteType from "@/Page/EssAdmin/Site/siteType/viewSiteType";

//Announcement
import Announcement from "@/Page/EssAdmin/Announcement/Announcement";
import newAnnouncement from "@/Page/EssAdmin/Announcement/newAnnouncement";
import viewAnnouncement from "@/Page/EssAdmin/Announcement/viewAnnouncement";
import editAnnouncement from "@/Page/EssAdmin/Announcement/editAnnouncement";
import Payslip from "@/Page/EssAdmin/CompanyManagement/Payslip/Payslip";
import Tax from "@/Page/EssAdmin/CompanyManagement/Tax/Tax";
import CustomForm from "@/Page/EssAdmin/CustomForm/CustomForm/CustomForm";
import editCustomForm from "@/Page/EssAdmin/CustomForm/CustomForm/editCustomForm";
import newCustomForm from "@/Page/EssAdmin/CustomForm/CustomForm/newCustomForm";
import viewCustomForm from "@/Page/EssAdmin/CustomForm/CustomForm/viewCustomForm";
import previewCustomForm from "@/Page/EssAdmin/CustomForm/CustomForm/previewCustomForm";
import CustomFormRecord from "@/Page/EssAdmin/CustomForm/CustomFormRecord/CustomFormRecord";
import viewCustomFormRecord from "@/Page/EssAdmin/CustomForm/CustomFormRecord/viewCustomFormRecord";
export default [
  //Approval Template
  {
    path: "approval-template",
    name: "Approval Template",
    component: Approval,
    meta: {
      router: "/admin/approval-template",
      icon: "",
      text: "label_essweb_approvalTemplate_list_title",
      bred: "/admin/approval-template",
    },
  },
  {
    path: "approval-template/detail/:id",
    name: "view Approval",
    component: viewApproval,
    meta: {
      router: "/admin/approval-template/detail/:id",
      icon: "",
      text: "label_essweb_approvalTemplate_form_viewTitle",
      bred: "/admin/approval-template/detail/:id",
    },
  },
  {
    path: "approval-template/edit/:id",
    name: "edit Approval",
    component: editApproval,
    meta: {
      router: "/admin/approval-template/edit/:id",
      icon: "",
      text: "label_essweb_approvalTemplate_form_editTitle",
      bred: "/admin/approval-template/edit/:id",
    },
  },
  {
    path: "approval-template/add",
    name: "newApproval",
    component: newApproval,
    meta: {
      router: "/admin/approval-template/add",
      icon: "",
      text: "label_essweb_approvalTemplate_form_newTitle",
      bred: "/admin/approval-template/add",
    },
  },
  // Approval Type
  {
    path: "approval-type",
    name: "Approval Type",
    component: ApprovalType,
    meta: {
      router: "/admin/approval-type",
      icon: "",
      text: "label_essweb_approvalType_list_title",
      bred: "/admin/approval-type",
    },
  },
  {
    path: "approval-type/detail/:id",
    name: "view ApprovalType",
    component: viewApprovalType,
    meta: {
      router: "/admin/approval-type/detail/:id",
      icon: "",
      text: "label_essweb_approvalType_form_viewTitle",
      bred: "/admin/approval-type/detail/:id",
    },
  },
  {
    path: "approval-type/edit/:id",
    name: "edit ApprovalType",
    component: editApprovalType,
    meta: {
      router: "/admin/approval-type/edit/:id",
      icon: "",
      text: "label_essweb_approvalType_form_editTitle",
      bred: "/admin/approval-type/edit/:id",
    },
  },
  {
    path: "approval-type/add",
    name: "newApprovalType",
    component: newApprovalType,
    meta: {
      router: "/admin/approval-type/add",
      icon: "",
      text: "label_essweb_approvalType_form_newTitle",
      bred: "/admin/approval-type/add",
    },
  },
  // Approval Process
  {
    path: "approval-process",
    name: "Approval Process",
    component: ApprovalProcess,
    meta: {
      router: "/admin/approval-process",
      icon: "",
      keepAlive: true,
      text: "label_essweb_approvalProcess_list_title",
      bred: "/admin/approval-process",
    },
  },
  // Approval Process-Claim
  {
    path: "approval-process/claim-detail/:params",
    name: "Claim ApprovalProcess",
    component: viewClaimApprovalProcess,
    meta: {
      router: "/admin/approval-process/claim-detail/:params",
      icon: "",
      cachePre: true, //缓存上一页
      text: "label_essweb_approvalProcess_form_claimTitle",
      bred: "/admin/approval-process/claim-detail/:params",
    },
  },
  {
    path: "approval-process/claim-detail/:params/approval-detail/:args",
    name: "claim ApprovalProcess Approval Detail",
    component: Status,
    meta: {
      router:
        "/admin/approval-process/claim-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/admin/approval-process/claim-detail/:params/approval-detail/:args",
    },
  },
  // Approval Process-Roster
  {
    path: "approval-process/roster-detail/:params",
    name: "Roster Approval Process",
    component: viewRosterApprovalProcess,
    meta: {
      router: "/admin/approval-process/roster-detail/:params",
      icon: "",
      cachePre: true, //缓存上一页
      text: "label_essweb_approvalProcess_form_rosterTitle",
      bred: "/admin/approval-process/roster-detail/:params",
    },
  },
  {
    path: "approval-process/roster-detail/:params/approval-detail/:args",
    name: "roster ApprovalProcess Approval Detail",
    component: Status,
    meta: {
      router:
        "/admin/approval-process/roster-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/admin/approval-process/roster-detail/:params/approval-detail/:args",
    },
  },
  // Approval Process-Attendance
  {
    path: "approval-process/attendance-detail/:params",
    name: "Attendance Approval Process",
    component: viewAttendanceApprovalProcess,
    meta: {
      router: "/admin/approval-process/attendance-detail/:params",
      cachePre: true, //缓存上一页
      icon: "",
      text: "label_essweb_approvalProcess_form_attendanceTitle",
      bred: "/admin/approval-process/attendance-detail/:params",
    },
  },
  {
    path: "approval-process/attendance-detail/:params/approval-detail/:args",
    name: "attendance ApprovalProcess Approval Detail",
    component: Status,
    meta: {
      router:
        "/admin/approval-process/attendance-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/admin/approval-process/attendance-detail/:params/approval-detail/:args",
    },
  },
  // Approval Process-Abnormal Clockin
  {
    path: "approval-process/abnormalClockin-detail/:params",
    name: "Abnormal Clockin ApprovalProcess",
    component: viewAbnormalClockinApprovalProcess,
    meta: {
      router: "/admin/approval-process/abnormalClockin-detail/:params",
      icon: "",
      cachePre: true, //缓存上一页
      text: "label_essweb_approvalProcess_form_abnormalClockinTitle",
      bred: "/admin/approval-process/abnormalClockin-detail/:params",
    },
  },
  {
    path: "approval-process/abnormalClockin-detail/:params/approval-detail/:args",
    name: "abnormalClockin ApprovalProcess Approval Detail",
    component: Status,
    meta: {
      router:
        "/admin/approval-process/abnormalClockin-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/admin/approval-process/abnormalClockin-detail/:params/approval-detail/:args",
    },
  },
  // Approval Process-Leave
  {
    path: "approval-process/leave-detail/:params",
    name: "Leave ApprovalProcess",
    component: viewLeaveApprovalProcess,
    meta: {
      router: "/admin/approval-process/leave-detail/:params",
      icon: "",
      text: "label_essweb_approvalProcess_form_leaveTitle",
      cachePre: true, //缓存上一页
      bred: "/admin/approval-process/leave-detail/:params",
    },
  },
  {
    path: "approval-process/leave-detail/:params/approval-detail/:args",
    name: "Leave ApprovalProcess Approval Detail",
    component: Status,
    meta: {
      router:
        "/admin/approval-process/leave-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/admin/approval-process/leave-detail/:params/approval-detail/:args",
    },
  },
  // Approval Process-Custom Form
  {
    path: "approval-process/custom-form-detail/:params",
    name: "custom form ApprovalProcess",
    component: viewCustomFormApprovalProcess,
    meta: {
      router: "/admin/approval-process/custom-form-detail/:params",
      icon: "",
      text: "label_essweb_approvalProcess_form_customFormTitle",
      cachePre: true, //缓存上一页
      bred: "/admin/approval-process/custom-form-detail/:params",
    },
  },
  {
    path: "approval-process/custom-form-detail/:params/approval-detail/:args",
    name: "custom form ApprovalProcess Approval Detail",
    component: Status,
    meta: {
      router:
        "/admin/approval-process/custom-form-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/admin/approval-process/custom-form-detail/:params/approval-detail/:args",
    },
  },
  // Flow Templates Message Config
  {
    path: "flow-template-message",
    name: "Flow Templates Message Config",
    component: MessageConfig,
    meta: {
      router: "/admin/flow-template-message",
      icon: "",
      text: "label_essweb_FlowTemplatesMessage_list_title",
      bred: "/admin/flow-template-message",
    },
  },
  // Attenndance
  {
    path: "attendance",
    name: "Attendance",
    component: InternalUse,
    meta: {
      router: "/admin/attendance",
      icon: "",
      text: "label_essweb_attendanceInternal_list_title",
      bred: "/admin/attendance",
    },
  },
  {
    path: "attendance/detail/:id",
    name: "editAttendance",
    component: editInternalUse,
    meta: {
      router: "/admin/attendance/detail/:id",
      icon: "",
      text: "label_essweb_attendanceInternal_form_viewTitle",
      bred: "/admin/attendance/detail/:id",
    },
  },
  // Attendance Record
  {
    path: "attendance-record",
    name: "Attendance Record",
    component: AttendanceRecord,
    meta: {
      router: "/admin/attendance-record",
      icon: "",
      keepAlive: true,
      text: "label_essweb_attendanceRecord_list_title",
      bred: "/admin/attendance-record",
    },
  },
  {
    path: "attendance-record/detail/:params",
    name: "Attendance Record Detail",
    component: AttendanceRecordDetail,
    meta: {
      router: "/admin/attendance-record/detail/:params",
      icon: "",
      cachePre: true, //缓存上一页
      text: "label_essweb_attendanceInternal_form_viewTitle",
      bred: "/admin/attendance-record/detail/:params",
    },
  },
  {
    path: "attendance-record/detail/:params/approval-detail/:args",
    name: "attendance record Application Approval Detail",
    component: Status,
    meta: {
      router: "/admin/attendance-record/detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/admin/attendance-record/detail/:params/approval-detail/:args",
    },
  },
  // Internal Use
  {
    path: "attendance-internal",
    name: "InternalUse",
    component: InternalUse,
    meta: {
      router: "/admin/attendance-internal",
      keepAlive: true,
      icon: "",
      text: "label_essweb_attendanceInternal_list_title",
      bred: "/admin/attendance-internal",
    },
  },
  // {
  //   path: "attendance-internal/detail",
  //   name: "Attendance Internal Detail",
  //   component: editInternalUse,
  //   meta: {
  //     router: "/admin/attendance-internal/detail",
  //     icon: "",
  //     text: "label_essweb_attendanceInternal_form_viewTitle",
  //     bred: "/admin/attendance-internal/detail",
  //   },
  // },
  {
    path: "attendance-internal/attendance-internal-leave-application/:args",
    name: "LeaveApplication_InteralUse",
    component: LeaveApplication_InteralUse,
    meta: {
      router:
        "/admin/attendance-internal/attendance-internal-leave-application/:args",
      icon: "",
      text: "label_essweb_leaveApplication_list_title",
      cachePre: true, //缓存上一页
      bred: "/admin/attendance-internal/attendance-internal-leave-application/:args",
    },
  },
  {
    path: "attendance-internal/attendance-internal-leave-application/add/:args",
    name: "newLeaveApplication_InteralUse",
    component: addLeaveApplication_InteralUse,
    meta: {
      router:
        "/admin/attendance-internal/attendance-internal-leave-application/add/:args",
      icon: "",
      text: "label_essweb_leaveApplication_form_newTitle",
      bred: "/admin/attendance-internal/attendance-internal-leave-application/add/:args",
    },
  },
  {
    path: "attendance-internal/attendance-internal-leave-application/detail/:id",
    name: "viewLeaveApplication_InteralUse",
    component: viewLeaveApplication_InteralUse,
    meta: {
      router:
        "/admin/attendance-internal/attendance-internal-leave-application/detail/:id",
      icon: "",
      text: "label_essweb_leaveApplication_form_viewTitle",
      bred: "/admin/attendance-internal/attendance-internal-leave-application/detail/:id",
    },
  },
  // Attendance Modification Application
  {
    path: "attendance-modification",
    name: "Attendance Modification Application",
    component: AttendanceRecordModiApp,
    meta: {
      router: "/admin/attendance-modification",
      icon: "",
      text: "label_essweb_attendanceModifiApp_list_title",
      bred: "/admin/attendance-modification",
    },
  },
  {
    path: "attendance-modification/detail/:params",
    name: "Application Detail",
    component: viewAttendanceRecordModiApp,
    meta: {
      router: "/admin/attendance-modification/detail/:params",
      icon: "",
      text: "label_essweb_attendanceModifiApp_form_viewTitle",
      bred: "/admin/attendance-modification/detail/:params",
    },
  },
  {
    path: "attendance-modification/detail/:params/approval-detail/:args",
    name: "attendance Application Approval Detail",
    component: Status,
    meta: {
      router:
        "/admin/attendance-modification/detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/admin/attendance-modification/detail/:params/approval-detail/:args",
    },
  },
  // Attendance Modification Reason
  {
    path: "attendance-modification-reason",
    name: "Attendance Modification Reason",
    component: AttendanceModiReason,
    meta: {
      router: "/admin/attendance-modification-reason",
      icon: "",
      text: "label_essweb_attendanceModifiReason_list_title",
      bred: "/admin/attendance-modification-reason",
    },
  },
  {
    path: "attendance-modification-reason/add",
    name: " New Attendance Modify Reason",
    component: newAttendanceModiReason,
    meta: {
      router: "/admin/attendance-modification-reason/add",
      icon: "",
      text: "label_essweb_attendanceModifiReason_form_newTitle",
      bred: "/admin/attendance-modification-reason/add",
    },
  },
  {
    path: "attendance-modification-reason/detail/:id",
    name: "  Attendance Modify Reason Detail",
    component: viewAttendanceModiReason,
    meta: {
      router: "/admin/attendance-modification-reason/detail/:id",
      icon: "",
      text: "label_essweb_attendanceModifiReason_form_viewTitle",
      bred: "/admin/attendance-modification-reason/detail/:id",
    },
  },
  {
    path: "attendance-modification-reason/edit/:id",
    name: "  Attendance Modify Reason Editer",
    component: editAttendanceModiReason,
    meta: {
      router: "/admin/attendance-modification-reason/edit/:id",
      icon: "",
      text: "label_essweb_attendanceModifiReason_form_editTitle",
      bred: "/admin/attendance-modification-reason/edit/:id",
    },
  },
  //Staff Card
  {
    path: "staff-card",
    name: " Staff Card",
    component: StaffCard,
    meta: {
      router: "/admin/staff-card",
      icon: "",
      text: "label_essweb_StaffCard_list_title",
      bred: "/admin/staff-card",
    },
  },
  // Claim Transaction Property Group
  {
    path: "claim-transaction-policy",
    name: "Claim Transaction Property Group",
    component: ClaimTransactionPropertyGroup,
    meta: {
      router: "/admin/claim-transaction-policy",
      icon: "",
      text: "label_essweb_ClaimTransactionPropertyGroup_list_title",
      bred: "/admin/claim-transaction-policy",
    },
  },
  {
    path: "claim-transaction-policy/add",
    name: "New Claim Transaction Property Group",
    component: newClaimTransactionPropertyGroup,
    meta: {
      router: "/admin/claim-transaction-policy/add",
      icon: "",
      text: "label_essweb_ClaimTransactionPropertyGroup_form_newTitle",
      bred: "/admin/claim-transaction-policy/add",
    },
  },
  {
    path: "claim-transaction-policy/detail/:id",
    name: " Claim Transaction Property Group Detail",
    component: viewClaimTransactionPropertyGroup,
    meta: {
      router: "/admin/claim-transaction-policy/detail/:id",
      icon: "",
      text: "label_essweb_ClaimTransactionPropertyGroup_form_viewTitle",
      bred: "/admin/claim-transaction-policy/detail/:id",
    },
  },
  {
    path: "claim-transaction-policy/edit/:id",
    name: "Edit Claim Transaction Property Group",
    component: editClaimTransactionPropertyGroup,
    meta: {
      router: "/admin/claim-transaction-policy/edit/:id",
      icon: "",
      text: "label_essweb_ClaimTransactionPropertyGroup_form_editTitle",
      bred: "/admin/claim-transaction-policy/edit/:id",
    },
  },
  // Claim Type Property Group
  {
    path: "claim-type-policy",
    name: "Claim Type Property Group",
    component: ClaimTypePropertyGroup,
    meta: {
      router: "/admin/claim-type-policy",
      icon: "",
      text: "label_essweb_ClaimTypePropertyGroup_list_title",
      bred: "/admin/claim-type-policy",
    },
  },
  {
    path: "claim-type-policy/add",
    name: "New Claim Type Property Group",
    component: newClaimTypePropertyGroup,
    meta: {
      router: "/admin/claim-type-policy/add",
      icon: "",
      text: "label_essweb_ClaimTypePropertyGroup_form_newTitle",
      bred: "/admin/claim-type-policy/add",
    },
  },
  {
    path: "claim-type-policy/detail/:id",
    name: " Claim Type Property Group Detail",
    component: viewClaimTypePropertyGroup,
    meta: {
      router: "/admin/claim-type-policy/detail/:id",
      icon: "",
      text: "label_essweb_ClaimTypePropertyGroup_form_viewTitle",
      bred: "/admin/claim-type-policy/detail/:id",
    },
  },
  {
    path: "claim-type-policy/edit/:id",
    name: "Edit Claim Type Property Group",
    component: editClaimTypePropertyGroup,
    meta: {
      router: "/admin/claim-type-policy/edit/:id",
      icon: "",
      text: "label_essweb_ClaimTypePropertyGroup_form_editTitle",
      bred: "/admin/claim-type-policy/edit/:id",
    },
  },
  // Claim Reason
  {
    path: "claim-reason",
    name: "Claim Reason",
    component: ClaimReason,
    meta: {
      router: "/admin/claim-reason",
      icon: "",
      text: "label_essweb_ClaimReason_list_title",
      bred: "/admin/claim-reason",
    },
  },
  {
    path: "claim-reason/add",
    name: "New Claim Reason",
    component: newClaimReason,
    meta: {
      router: "/admin/claim-reason/add",
      icon: "",
      text: "label_essweb_ClaimReason_form_newTitle",
      bred: "/admin/claim-reason/add",
    },
  },
  {
    path: "claim-reason/detail/:id",
    name: "Claim Reason Detail",
    component: viewClaimReason,
    meta: {
      router: "/admin/claim-reason/detail/:id",
      icon: "",
      text: "label_essweb_ClaimReason_form_viewTitle",
      bred: "/admin/claim-reason/detail/:id",
    },
  },
  {
    path: "claim-reason/edit/:id",
    name: "Edit Claim Reason Detail",
    component: editClaimReason,
    meta: {
      router: "/admin/claim-reason/edit/:id",
      icon: "",
      text: "label_essweb_ClaimReason_form_editTitle",
      bred: "/admin/claim-reason/edit/:id",
    },
  },
  // Claim Balance
  {
    path: "claim-balance",
    name: "Admin Claim Balance",
    component: ClaimBalance,
    meta: {
      router: "/admin/claim-balance",
      icon: "",
      text: "label_essweb_ClaimBalance_list_title",
      bred: "/admin/claim-balance",
    },
  },
  {
    path: "claim-balance/detail/:id",
    name: "View Claim Balance",
    component: viewClaimBalance,
    meta: {
      router: "/admin/claim-balance/detail/:id",
      icon: "",
      text: "label_essweb_ClaimBalance_form_viewTitle",
      bred: "/admin/claim-balance/detail/:id",
    },
  },
  // Claim Record
  {
    path: "claim-record",
    name: "Claim Record",
    component: ClaimRecord,
    meta: {
      router: "/admin/claim-record",
      keepAlive: true,
      icon: "",
      text: "label_essweb_ClaimRecord_list_title",
      bred: "/admin/claim-record",
    },
  },
  {
    path: "claim-record/detail/item/:id",
    name: "Claim Item",
    component: ClaimRecordItem,
    meta: {
      router: "/admin/claim-record/detail/item/:id",
      icon: "",
      text: "label_essweb_ClaimRecord_form_viewTitle",
      bred: "/admin/claim-record/detail/item/:id",
    },
  },
  {
    path: "claim-record/detail/:params",
    name: "Claim Record Detail",
    component: editClaimRecord,
    meta: {
      router: "/admin/claim-record/detail/:params",
      icon: "",
      text: "label_essweb_ClaimRecord_form_viewTitle",
      bred: "/admin/claim-record/detail/:params",
    },
  },
  {
    path: "claim-record/detail/:params/approval-detail/:args",
    name: "Claim Record Detail approval Detail",
    component: Status,
    meta: {
      router: "/admin/claim-record/detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/admin/claim-record/detail/:params/approval-detail/:args",
    },
  },
  // Claim Type
  {
    path: "claim-type",
    name: "Claim Type",
    component: ClaimType,
    meta: {
      router: "/admin/claim-type",
      icon: "",
      text: "label_essweb_ClaimType_list_title",
      bred: "/admin/claim-type",
    },
  },
  {
    path: "claim-type/add",
    name: "New Claim Type",
    component: newClaimType,
    meta: {
      router: "/admin/claim-type/add",
      icon: "",
      text: "label_essweb_ClaimType_form_newTitle",
      bred: "/admin/claim-type/add",
    },
  },
  {
    path: "claim-type/detail/:id",
    name: "Claim Type Detail",
    component: viewClaimType,
    meta: {
      router: "/admin/claim-type/detail/:id",
      icon: "",
      text: "label_essweb_ClaimType_form_viewTitle",
      bred: "/admin/claim-type/detail/:id",
    },
  },
  {
    path: "claim-type/edit/:id",
    name: "Edit Claim Type Detail",
    component: editClaimType,
    meta: {
      router: "/admin/claim-type/edit/:id",
      icon: "",
      text: "label_essweb_ClaimType_form_editTitle",
      bred: "/admin/claim-type/edit/:id",
    },
  },
  //Claim Item Type
  {
    path: "claim-item",
    name: "Claim Item Type",
    component: ClaimItemType,
    meta: {
      router: "/admin/claim-item",
      icon: "",
      text: "label_essweb_ClaimItemType_list_title",
      bred: "/admin/claim-item",
    },
  },
  {
    path: "claim-item/add",
    name: "New Claim Item Type",
    component: newClaimItemType,
    meta: {
      router: "/admin/claim-item/add",
      icon: "",
      text: "label_essweb_ClaimItemType_form_newTitle",
      bred: "/admin/claim-item/add",
    },
  },
  {
    path: "claim-item/detail/:id",
    name: "Claim Item Type Detail",
    component: viewClaimItemType,
    meta: {
      router: "/admin/claim-item/detail/:id",
      icon: "",
      text: "label_essweb_ClaimItemType_form_viewTitle",
      bred: "/admin/claim-item/detail/:id",
    },
  },
  {
    path: "claim-item/edit/:id",
    name: "Edit Claim Item Type Detail",
    component: editClaimItemType,
    meta: {
      router: "/admin/claim-item/edit/:id",
      icon: "",
      text: "label_essweb_ClaimItemType_form_editTitle",
      bred: "/admin/claim-item/edit/:id",
    },
  },
  // Event
  {
    path: "event-management",
    name: "Event",
    component: EventList,
    meta: {
      router: "/admin/event-management",
      icon: "",
      text: "label_essweb_event_list_title",
      bred: "/admin/event-management",
    },
  },
  {
    path: "event-management/add",
    name: "New Event",
    component: newEvent,
    meta: {
      router: "/admin/event-management/add",
      icon: "",
      text: "label_essweb_event_form_newTitle",
      bred: "/admin/event-management/add",
    },
  },
  {
    path: "event-management/edit/:params",
    name: "Edit Event Detail",
    component: editEvent,
    meta: {
      router: "/admin/event-management/edit/:params",
      icon: "",
      text: "label_essweb_event_form_editTitle",
      bred: "/admin/event-management/edit/:params",
    },
  },
  {
    path: "event-management/detail/:params",
    name: "View Event Detail",
    component: viewEvent,
    meta: {
      router: "/admin/event-management/detail/:params",
      icon: "",
      text: "label_essweb_event_form_viewTitle",
      bred: "/admin/event-management/detail/:params",
    },
  },
  //Event Type
  {
    path: "event-type",
    name: "Event Type",
    component: EventType,
    meta: {
      router: "/admin/event-type",
      icon: "",
      text: "label_essweb_eventType_list_title",
      bred: "/admin/event-type",
    },
  },
  {
    path: "event-type/add",
    name: "New Event Type",
    component: newEventType,
    meta: {
      router: "/admin/event-type/add",
      icon: "",
      text: "label_essweb_eventType_from_newTitle",
      bred: "/admin/event-type/add",
    },
  },
  {
    path: "event-type/detail/:id",
    name: "Event Type Detail",
    component: viewEventType,
    meta: {
      router: "/admin/event-type/detail/:id",
      icon: "",
      text: "label_essweb_eventType_from_viewTitle",
      bred: "/admin/event-type/detail/:id",
    },
  },
  {
    path: "event-type/edit/:id",
    name: "Edit Event Type Detail",
    component: editEventType,
    meta: {
      router: "/admin/event-type/edit/:id",
      icon: "",
      text: "label_essweb_eventType_from_editTitle",
      bred: "/admin/event-type/edit/:id",
    },
  },
  // Event Property Group
  {
    path: "event-policy",
    name: "Event Property Group",
    component: EventPropertyGroup,
    meta: {
      router: "/admin/event-policy",
      icon: "",
      text: "label_essweb_eventPropertyGroup_list_title",
      bred: "/admin/event-policy",
    },
  },
  {
    path: "event-policy/add",
    name: "New Event Property Group",
    component: newEventPropertyGroup,
    meta: {
      router: "/admin/event-policy/add",
      icon: "",
      text: "label_essweb_eventPropertyGroup_form_newTitle",
      bred: "/admin/event-policy/add",
    },
  },
  {
    path: "event-policy/detail/:id",
    name: "Event Property Group Detail",
    component: viewEventPropertyGroup,
    meta: {
      router: "/admin/event-policy/detail/:id",
      icon: "",
      text: "label_essweb_eventPropertyGroup_form_viewTitle",
      bred: "/admin/event-policy/detail/:id",
    },
  },
  {
    path: "event-policy/edit/:id",
    name: "Edit Event Property Group Detail",
    component: editEventPropertyGroup,
    meta: {
      router: "/admin/event-policy/edit/:id",
      icon: "",
      text: "label_essweb_eventPropertyGroup_form_editTitle",
      bred: "/admin/event-policy/edit/:id",
    },
  },
  // Message Type
  {
    path: "message-type",
    name: "Message Type",
    component: MessageType,
    meta: {
      router: "/admin/message-type",
      icon: "",
      text: "label_essweb_MessageType_list_title",
      bred: "/admin/message-type",
    },
  },
  // Public Holiday
  {
    path: "public-holiday",
    name: "Public Holiday",
    component: PublicHoliday,
    meta: {
      router: "/admin/public-holiday",
      icon: "",
      text: "label_essweb_holiday_list_title",
      bred: "/admin/public-holiday",
    },
  },
  {
    path: "public-holiday/add",
    name: "New Public Holiday",
    component: newPublicHoliday,
    meta: {
      router: "/admin/public-holiday/add",
      icon: "",
      text: "label_essweb_holiday_form_newTitle",
      bred: "/admin/public-holiday/add",
    },
  },
  {
    path: "public-holiday/detail/:id",
    name: "Public Holiday Detail",
    component: viewPublicHoliday,
    meta: {
      router: "/admin/public-holiday/detail/:id",
      icon: "",
      text: "label_essweb_holiday_form_viewTitle",
      bred: "/admin/public-holiday/detail/:id",
    },
  },
  {
    path: "public-holiday/edit/:id",
    name: "Edit Public Holiday ",
    component: editPublicHoliday,
    meta: {
      router: "/admin/public-holiday/edit/:id",
      icon: "",
      text: "label_essweb_holiday_form_editTitle",
      bred: "/admin/public-holiday/edit/:id",
    },
  },
  //Public Holiday Group
  {
    path: "holiday-group",
    name: "Public Holiday Group",
    component: PublicHolidayGroup,
    meta: {
      router: "/admin/holiday-group",
      icon: "",
      text: "label_essweb_holidayGroup_list_title",
      bred: "/admin/holiday-group",
    },
  },
  {
    path: "holiday-group/add",
    name: "New Public Holiday Group",
    component: newPublicHolidayGroup,
    meta: {
      router: "/admin/holiday-group/add",
      icon: "",
      text: "label_essweb_holidayGroup_form_newTitle",
      bred: "/admin/holiday-group/add",
    },
  },
  {
    path: "holiday-group/detail/:id",
    name: "Public Holiday Group Detail",
    component: viewPublicHolidayGroup,
    meta: {
      router: "/admin/holiday-group/detail/:id",
      icon: "",
      text: "label_essweb_holidayGroup_form_viewTitle",
      bred: "/admin/holiday-group/detail/:id",
    },
  },
  {
    path: "holiday-group/edit/:id",
    name: "Edit Public Holiday Group ",
    component: editPublicHolidayGroup,
    meta: {
      router: "/admin/holiday-group/edit/:id",
      icon: "",
      text: "label_essweb_holidayGroup_form_editTitle",
      bred: "/admin/holiday-group/edit/:id",
    },
  },
  // Public Holiday Type
  {
    path: "holiday-type",
    name: "Public Holiday Type",
    component: HolidayType,
    meta: {
      router: "/admin/holiday-type",
      icon: "",
      text: "label_essweb_holidayType_list_title",
      bred: "/admin/holiday-type",
    },
  },
  {
    path: "holiday-type/add",
    name: "New Public Holiday Type",
    component: newHolidayType,
    meta: {
      router: "/admin/holiday-type/add",
      icon: "",
      text: "label_essweb_holidayType_form_newTitle",
      bred: "/admin/holiday-type/add",
    },
  },
  {
    path: "holiday-type/detail/:id",
    name: "Public Holiday Type Detail",
    component: viewHolidayType,
    meta: {
      router: "/admin/holiday-type/detail/:id",
      icon: "",
      text: "label_essweb_holidayType_form_viewTitle",
      bred: "/admin/holiday-type/detail/:id",
    },
  },
  {
    path: "holiday-type/edit/:id",
    name: "Edit Public Holiday Type ",
    component: editHolidayType,
    meta: {
      router: "/admin/holiday-type/edit/:id",
      icon: "",
      text: "label_essweb_holidayType_form_editTitle",
      bred: "/admin/holiday-type/edit/:id",
    },
  },
  // Block Leave
  {
    path: "block-leave-policy",
    name: "block leave policy",
    component: BlockLeaveGroup,
    meta: {
      router: "/admin/block-leave-policy",
      icon: "",
      text: "label_essweb_BlockLeavePolicy_list_title",
      bred: "/admin/block-leave-policy",
    },
  },
  {
    path: "block-leave-policy/detail/:params",
    name: "block leave policy detail",
    component: viewBlockLeaveGroup,
    meta: {
      router: "/admin/block-leave-policy/detail/:params",
      icon: "",
      text: "label_essweb_BlockLeavePolicy_form_viewTitle",
      bred: "/admin/block-leave-policy/detail/:params",
    },
  },
  {
    path: "block-leave-policy/add/:args",
    name: "block leave policy New",
    component: newBlockLeaveGroup,
    meta: {
      router: "/admin/block-leave-policy/add/:args",
      icon: "",
      text: "label_essweb_BlockLeavePolicy_form_newTitle",
      bred: "/admin/block-leave-policy/add/:args",
    },
  },
  {
    path: "block-leave-policy/edit/:params",
    name: "block leave policy Edit",
    component: editBlockLeaveGroup,
    meta: {
      router: "/admin/block-leave-policy/edit/:params",
      icon: "",
      text: "label_essweb_BlockLeavePolicy_form_editTitle",
      bred: "/admin/block-leave-policy/edit/:params",
    },
  },
  {
    path: "block-leave-record",
    name: "block leave record",
    component: BlockLeaveRecord,
    meta: {
      router: "/admin/block-leave-record",
      icon: "",
      text: "label_essweb_BlockLeaveRecord_list_title",
      bred: "/admin/block-leave-record",
    },
  },
  {
    path: "block-leave-mapping",
    name: "block leave mapping",
    component: BlockLeaveMapping,
    meta: {
      router: "/admin/block-leave-mapping",
      icon: "",
      text: "label_essweb_BlockLeaveMapping_list_title",
      bred: "/admin/block-leave-mapping",
    },
  },
  // Leave
  {
    path: "leave-application",
    name: "Leave Application",
    component: LeaveApplication,
    meta: {
      router: "/admin/leave-application",
      icon: "",
      keepAlive: true,
      text: "label_essweb_leaveApplication_list_title",
      bred: "/admin/leave-application",
    },
  },
  {
    path: "leave-application/detail/:params",
    name: "Leave Application Detail",
    component: viewLeaveApplication,
    meta: {
      router: "/admin/leave-application/detail/:params",
      icon: "",
      cachePre: true,
      text: "label_essweb_leaveApplication_form_viewTitle",
      bred: "/admin/leave-application/detail/:params",
    },
  },
  {
    path: "leave-application/detail/:params/approval-detail/:args",
    name: "Admin Leave Approval Detail",
    component: Status,
    meta: {
      router: "/admin/leave-application/detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/admin/leave-application/detail/:params/approval-detail/:args",
    },
  },
  //Leave Balance
  {
    path: "leave-balance",
    name: "Admin Leave Balance",
    component: LeaveBalance,
    meta: {
      router: "/admin/leave-balance",
      icon: "",
      text: "label_essweb_leaveBalance_list_title",
      bred: "/admin/leave-balance",
    },
  },
  // {
  //   path: "leave-balance/detail",
  //   name: "Leave Balance Detail",
  //   component: editLeaveBalance,
  //   meta: {
  //     router: "/admin/leave-balance/detail",
  //     icon: "",
  //     text: "label_essweb_leaveBalance_form_viewTitle",
  //     bred: "/admin/leave-balance/detail",
  //   },
  // },
  //// Leave Reason
  {
    path: "leave-reason",
    name: "Leave Reason",
    component: LeaveReason,
    meta: {
      router: "/admin/leave-reason",
      icon: "",
      text: "label_essweb_leaveReason_list_title",
      bred: "/admin/leave-reason",
    },
  },
  {
    path: "leave-reason/add",
    name: "New Leave Reason",
    component: newLeaveReason,
    meta: {
      router: "/admin/leave-reason/add",
      icon: "",
      text: "label_essweb_leaveReason_form_newTitle",
      bred: "/admin/leave-reason/add",
    },
  },
  {
    path: "leave-reason/detail/:id",
    name: "Leave Reason Detail",
    component: viewLeaveReason,
    meta: {
      router: "/admin/leave-reason/detail/:id",
      icon: "",
      text: "label_essweb_leaveReason_form_viewTitle",
      bred: "/admin/leave-reason/detail/:id",
    },
  },
  {
    path: "leave-reason/edit/:id",
    name: "Edit Leave Reason Detail",
    component: editLeaveReason,
    meta: {
      router: "/admin/leave-reason/edit/:id",
      icon: "",
      text: "label_essweb_leaveReason_form_editTitle",
      bred: "/admin/leave-reason/edit/:id",
    },
  },
  //Leave Cancellation Reason
  {
    path: "leave-cancellation-reason",
    name: "Leave Cancellation Reason",
    component: LeaveCanaelReason,
    meta: {
      router: "/admin/leave-cancellation-reason",
      icon: "",
      text: "label_essweb_leaveCancelReason_list_title",
      bred: "/admin/leave-cancellation-reason",
    },
  },
  {
    path: "leave-cancellation-reason/add",
    name: "New Leave Cancellation Reason ",
    component: newLeaveCanaelReason,
    meta: {
      router: "/admin/leave-cancellation-reason/add",
      icon: "",
      text: "label_essweb_leaveCancelReason_from_newTitle",
      bred: "/admin/leave-cancellation-reason/add",
    },
  },
  {
    path: "leave-cancellation-reason/detail/:id",
    name: "View Leave Cancellation Reason",
    component: viewLeaveCanaelReason,
    meta: {
      router: "/admin/leave-cancellation-reason/detail/:id",
      icon: "",
      text: "label_essweb_leaveCancelReason_from_viewTitle",
      bred: "/admin/leave-cancellation-reason/detail/:id",
    },
  },
  {
    path: "leave-cancellation-reason/edit/:id",
    name: "Edit Leave Cancellation Reason",
    component: editLeaveCanaelReason,
    meta: {
      router: "/admin/leave-cancellation-reason/edit/:id",
      icon: "",
      text: "label_essweb_leaveCancelReason_from_editTitle",
      bred: "/admin/leave-cancellation-reason/edit/:id",
    },
  },
  //Leave Transaction Property Group
  {
    path: "leave-transaction-policy",
    name: "Leave Transaction Property Group",
    component: LeaveTransactionPropertyGroup,
    meta: {
      router: "/admin/leave-transaction-policy",
      icon: "",
      text: "label_essweb_leaveTransactionPropertyGroup_list_title",
      bred: "/admin/leave-transaction-policy",
    },
  },
  {
    path: "leave-transaction-policy/add",
    name: "New Leave Transaction Property Group",
    component: newLeaveTransactionPropertyGroup,
    meta: {
      router: "/admin/leave-transaction-policy/add",
      icon: "",
      text: "label_essweb_leaveTransactionPropertyGroup_form_newTitle",
      bred: "/admin/leave-transaction-policy/add",
    },
  },
  {
    path: "leave-transaction-policy/detail/:id",
    name: "Leave Transaction Property Group Detail",
    component: viewLeaveTransactionPropertyGroup,
    meta: {
      router: "/admin/leave-transaction-policy/detail/:id",
      icon: "",
      text: "label_essweb_leaveTransactionPropertyGroup_form_viewTitle",
      bred: "/admin/leave-transaction-policy/detail/:id",
    },
  },
  {
    path: "leave-transaction-policy/edit/:id",
    name: "Edit Leave Transaction Property Group Detail",
    component: editLeaveTransactionPropertyGroup,
    meta: {
      router: "/admin/leave-transaction-policy/edit/:id",
      icon: "",
      text: "label_essweb_leaveTransactionPropertyGroup_form_editTitle",
      bred: "/admin/leave-transaction-policy/edit/:id",
    },
  },
  //Leave Type
  {
    path: "leave-type",
    name: "Leave Type",
    component: LeaveType,
    meta: {
      router: "/admin/leave-type",
      icon: "",
      text: "label_essweb_leaveType_list_title",
      bred: "/admin/leave-type",
    },
  },
  {
    path: "leave-type/add",
    name: "New Leave Type",
    component: newLeaveType,
    meta: {
      router: "/admin/leave-type/add",
      icon: "",
      text: "label_essweb_leaveType_form_newTitle",
      bred: "/admin/leave-type/add",
    },
  },
  {
    path: "leave-type/detail/:id",
    name: " Leave Type Detail",
    component: viewLeaveType,
    meta: {
      router: "/admin/leave-type/detail/:id",
      icon: "",
      text: "label_essweb_leaveType_form_viewTitle",
      bred: "/admin/leave-type/detail/:id",
    },
  },
  {
    path: "leave-type/edit/:id",
    name: "Edit Leave Type Detail",
    component: editLeaveType,
    meta: {
      router: "/admin/leave-type/edit/:id",
      icon: "",
      text: "label_essweb_leaveType_form_editTitle",
      bred: "/admin/leave-type/edit/:id",
    },
  },
  //Leave Type Property Group
  {
    path: "leave-type-policy",
    name: "Leave Type Property Group",
    component: LeaveTypePropertyGroup,
    meta: {
      router: "/admin/leave-type-policy",
      icon: "",
      keepAlive: true,
      text: "label_essweb_leaveTypePropertyGroup_list_title",
      bred: "/admin/leave-type-policy",
    },
  },
  {
    path: "leave-type-policy/add",
    name: "New Leave Type Property Group",
    component: newLeaveTypePropertyGroup,
    meta: {
      router: "/admin/leave-type-policy/add",
      icon: "",
      cachePre: true,

      text: "label_essweb_leaveTypePropertyGroup_form_newTitle",
      bred: "/admin/leave-type-policy/add",
    },
  },
  {
    path: "leave-type-policy/detail/:id",
    name: " Leave Type Property Group Detail",
    component: viewLeaveTypePropertyGroup,
    meta: {
      router: "/admin/leave-type-policy/detail/:id",
      cachePre: true,
      icon: "",
      text: "label_essweb_leaveTypePropertyGroup_form_viewTitle",
      bred: "/admin/leave-type-policy/detail/:id",
    },
  },
  {
    path: "leave-type-policy/edit/:id",
    name: "Edit Leave Type Property Group Detail",
    component: editLeaveTypePropertyGroup,
    meta: {
      router: "/admin/leave-type-policy/edit/:id",
      cachePre: true,
      icon: "",
      text: "label_essweb_leaveTypePropertyGroup_form_editTitle",
      bred: "/admin/leave-type-policy/edit/:id",
    },
  },
  // Punch Criteria Type
  {
    path: "clock-in-criteria",
    name: "Punch Criteria Type",
    component: PunchCriteriaType,
    meta: {
      router: "/admin/clock-in-criteria",
      icon: "",
      text: "label_essweb_punchCriteriaType_list_title",
      bred: "/admin/clock-in-criteria",
    },
  },
  // Punch Manage
  {
    path: "clock-in-management",
    name: "Punch Manage",
    component: PunchManage,
    meta: {
      router: "/admin/clock-in-management",
      icon: "",
      text: "label_essweb_punchManage_list_title",
      bred: "/admin/clock-in-management",
    },
  },
  // Punch Record
  {
    path: "clock-in",
    name: "Punch Record",
    component: PunchRecord,
    meta: {
      router: "/admin/clock-in",
      icon: "",
      text: "label_essweb_punchRecord_list_title",
      bred: "/admin/clock-in",
    },
  },
  // Abnormal Clock-in
  {
    path: "abnormal-clock-in",
    name: "Abnormal Clock-in",
    component: AbnormalClockin,
    meta: {
      router: "/admin/abnormal-clock-in",
      icon: "",
      text: "label_essweb_abnormalClockin_list_title",
      bred: "/admin/abnormal-clock-in",
    },
  },
  {
    path: "abnormal-clock-in/detail/:params",
    name: "Punch Verify Failed Application Detail",
    component: viewAbnormalClockin,
    meta: {
      router: "/admin/abnormal-clock-in/detail/:params",
      icon: "",
      text: "label_essweb_abnormalClockin_form_title",
      bred: "/admin/abnormal-clock-in/detail/:params",
    },
  },
  {
    path: "abnormal-clock-in/detail/:params/approval-detail/:args",
    name: "Punch Verify Failed Application Approval Detail",
    component: Status,
    meta: {
      router: "/admin/abnormal-clock-in/detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/admin/abnormal-clock-in/detail/:params/approval-detail/:args",
    },
  },
  // Abnormal Punch Reason
  {
    path: "abnormal-clock-in-reason",
    name: "Abnormal Punch Reason",
    component: AbnormalPunchReason,
    meta: {
      router: "/admin/abnormal-clock-in-reason",
      icon: "",
      text: "label_essweb_abnormalPunchReason_list_title",
      bred: "/admin/abnormal-clock-in-reason",
    },
  },

  {
    path: "abnormal-clock-in-reason/add",
    name: "New Punch Verify Failed Reason",
    component: newAbnormalPunchReason,
    meta: {
      router: "/admin/abnormal-clock-in-reason/add",
      icon: "",
      text: "label_essweb_abnormalPunchReason_form_newTitle",
      bred: "/admin/abnormal-clock-in-reason/add",
    },
  },
  {
    path: "abnormal-clock-in-reason/detail/:id",
    name: "Punch Verify Failed Reason Detail",
    component: viewAbnormalPunchReason,
    meta: {
      router: "/admin/abnormal-clock-in-reason/detail/:id",
      icon: "",
      text: "label_essweb_abnormalPunchReason_form_viewTitle",
      bred: "admin/abnormal-clock-in-reason/detail/:id",
    },
  },
  {
    path: "abnormal-clock-in-reason/edit/:id",
    name: "Punch Verify Failed Reason Editer",
    component: editAbnormalPunchReason,
    meta: {
      router: "/admin/abnormal-clock-in-reason/edit/:id",
      icon: "",
      text: "label_essweb_abnormalPunchReason_form_editTitle",
      bred: "admin/abnormal-clock-in-reason/edit/:id",
    },
  },
  //Roster
  {
    path: "roster-form-template",
    name: "Roster Form",
    component: RosterForm,
    meta: {
      router: "/admin/roster-form-template",
      icon: "",
      text: "label_essweb_RosterForm_list_title",
      bred: "/admin/roster-form-template",
    },
  },
  {
    path: "roster-form-template/add",
    name: "New Roster Form",
    component: newRosterForm,
    meta: {
      router: "/admin/roster-form-template/add",
      icon: "",
      text: "label_essweb_RosterForm_form_newTitle",
      bred: "/admin/roster-form-template/add",
    },
  },
  {
    path: "roster-form-template/detail/:id",
    name: " Roster Form Detail",
    component: viewRosterForm,
    meta: {
      router: "/admin/roster-form-template/detail/:id",
      icon: "",
      text: "label_essweb_RosterForm_form_viewTitle",
      bred: "/admin/roster-form-template/detail/:id",
    },
  },
  {
    path: "roster-form-template/edit/:id",
    name: "Edit Roster Form Detail",
    component: editRosterForm,
    meta: {
      router: "/admin/roster-form-template/edit/:id",
      icon: "",
      text: "label_essweb_RosterForm_form_editTitle",
      bred: "/admin/roster-form-template/edit/:id",
    },
  },
  // Roster Property Group
  {
    path: "roster-policy",
    name: "Roster Property Group",
    component: RosterPropertyGroup,
    meta: {
      router: "/admin/roster-policy",
      icon: "",
      text: "label_essweb_RosterPropertyGroup_list_title",
      bred: "/admin/roster-policy",
    },
  },
  {
    path: "roster-policy/add",
    name: "New Roster Property Group",
    component: newRosterPropertyGroup,
    meta: {
      router: "/admin/roster-policy/add",
      icon: "",
      text: "label_essweb_RosterPropertyGroup_form_newTitle",
      bred: "/admin/roster-policy/add",
    },
  },
  {
    path: "roster-policy/detail/:id",
    name: "Roster Property Group Detail",
    component: viewRosterPropertyGroup,
    meta: {
      router: "/admin/roster-policy/detail/:id",
      icon: "",
      text: "label_essweb_RosterPropertyGroup_form_viewTitle",
      bred: "/admin/roster-policy/detail/:id",
    },
  },
  {
    path: "roster-policy/edit/:id",
    name: "Edit Roster Property Group Detail",
    component: editRosterPropertyGroup,
    meta: {
      router: "/admin/roster-policy/edit/:id",
      icon: "",
      text: "label_essweb_RosterPropertyGroup_form_editTitle",
      bred: "/admin/roster-policy/edit/:id",
    },
  },
  // Roster Record
  {
    path: "duty-schedule",
    name: "Roster Record",
    component: RosterRecord,
    meta: {
      router: "/admin/duty-schedule",
      icon: "",
      text: "label_essweb_RosterRecord_list_title",
      bred: "/admin/duty-schedule",
    },
  },
  //Roster Form Record
  {
    path: "roster-form-record",
    name: "Roster Form Record",
    component: RosterFormRecord,
    meta: {
      router: "/admin/roster-form-record",
      icon: "",
      keepAlive: true,
      text: "label_essweb_RosterFormRecord_list_title",
      bred: "/admin/roster-form-record",
    },
  },
  {
    path: "roster-form-record/add",
    name: "New Roster Form Record",
    component: newRosterFormRecord,
    meta: {
      router: "/admin/roster-form-record/add",
      icon: "",
      cachePre: true,
      text: "label_essweb_RosterFormRecord_form_newTitle",
      bred: "/admin/roster-form-record/add",
    },
  },
  {
    path: "roster-form-record/detail/:id",
    name: "Roster Form Record Detail",
    component: viewRosterFormRecord,
    meta: {
      router: "/admin/roster-form-record/detail/:id",
      cachePre: true,
      icon: "",
      text: "label_essweb_RosterFormRecord_form_viewTitle",
      bred: "/admin/roster-form-record/detail/:id",
    },
  },
  {
    path: "roster-form-record/edit/:id",
    name: "Edit Roster Form Record Detail",
    component: editRosterFormRecord,
    meta: {
      router: "/admin/roster-form-record/edit/:id",
      cachePre: true,
      icon: "",
      text: "label_essweb_RosterFormRecord_form_editTitle",
      bred: "/admin/roster-form-record/edit/:id",
    },
  },
  //Roster Template
  {
    path: "roster-template",
    name: "Roster Template",
    component: RosterTemplate,
    meta: {
      router: "/admin/roster-template",
      icon: "",
      text: "label_essweb_RosterTemplate_list_title",
      bred: "/admin/roster-template",
    },
  },
  {
    path: "roster-template/add",
    name: "New Roster Template ",
    component: newRosterTemplate,
    meta: {
      router: "/admin/roster-template/add",
      icon: "",
      text: "label_essweb_RosterTemplate_form_newTitle",
      bred: "/admin/roster-template/add",
    },
  },
  {
    path: "roster-template/detail/:id",
    name: "Roster Template Detail",
    component: viewRosterTemplate,
    meta: {
      router: "/admin/roster-template/detail/:id",
      icon: "",
      text: "label_essweb_RosterTemplate_form_viewTitle",
      bred: "/admin/roster-template/detail/:id",
    },
  },
  {
    path: "roster-template/edit/:id",
    name: "Edit Roster Template Detail",
    component: editRosterTemplate,
    meta: {
      router: "/admin/roster-template/edit/:id",
      icon: "",
      text: "label_essweb_RosterTemplate_form_editTitle",
      bred: "/admin/roster-template/edit/:id",
    },
  },
  //Shift
  {
    path: "shift",
    name: "Shift",
    component: ShiftList,
    meta: {
      router: "/admin/shift",
      icon: "",
      entry: "admin-shift-entry",
      text: "label_essweb_shift_list_title",
      bred: "/admin/shift",
    },
  },
  {
    path: "shift/add",
    name: "New Shift",
    component: newShiftList,
    meta: {
      router: "/admin/shift/add",
      icon: "",
      text: "label_essweb_shift_form_newTitle",
      bred: "/admin/shift/add",
    },
  },
  {
    path: "shift/edit/:id",
    name: "Edit Shift Detail",
    component: editShiftList,
    meta: {
      router: "/admin/shift/edit/:id",
      icon: "",
      text: "label_essweb_shift_form_editTitle",
      bred: "/admin/shift/edit/:id",
    },
  },
  {
    path: "shift/detail/:id",
    name: "View Shift Detail",
    component: viewShiftList,
    meta: {
      router: "/admin/shift/detail/:id",
      icon: "",
      text: "label_essweb_shift_form_viewTitle",
      bred: "/admin/shift/detail/:id",
    },
  },
  //Shift Type
  {
    path: "shift-type",
    name: "Shift Type",
    component: ShiftType,
    meta: {
      router: "/admin/shift-type",
      icon: "",
      entry: "admin-shift-type-entry",
      text: "label_essweb_shiftType_list_title",
      bred: "/admin/shift-type",
    },
  },
  {
    path: "shift-type/add",
    name: "New Shift Type",
    component: newShiftType,
    meta: {
      router: "/admin/shift-type/add",
      icon: "",
      text: "label_essweb_shiftType_form_newTitle",
      bred: "/admin/shift-type/add",
    },
  },
  {
    path: "shift-type/edit/:id",
    name: "Edit Shift Type ",
    component: editShiftType,
    meta: {
      router: "/admin/shift-type/edit/:id",
      icon: "",
      text: "label_essweb_shiftType_form_editTitle",
      bred: "/admin/shift-type/edit/:id",
    },
  },
  {
    path: "shift-type/detail/:id",
    name: "View Shift Type ",
    component: viewShiftType,
    meta: {
      router: "/admin/shift-type/detail/:id",
      icon: "",
      text: "label_essweb_shiftType_form_viewTitle",
      bred: "/admin/shift-type/detail/:id",
    },
  },
  //Shift Property Group
  {
    path: "shift-policy",
    name: "Shift Property Group",
    component: ShiftPropertyGroup,
    meta: {
      router: "/admin/shift-policy",
      icon: "",
      text: "label_essweb_shiftPropertyGroup_list_title",
      bred: "/admin/shift-policy",
    },
  },
  {
    path: "shift-policy/detail/:id",
    name: "Shift Property Group Detail",
    component: viewShiftPropertyGroup,
    meta: {
      router: "/admin/shift-policy/detail/:id",
      icon: "",
      text: "label_essweb_shiftPropertyGroup_form_viewTitle",
      bred: "/admin/shift-policy/detail/:id",
    },
  },
  {
    path: "shift-policy/edit/:id",
    name: "Shift Property Group Edit",
    component: editShiftPropertyGroup,
    meta: {
      router: "/admin/shift-policy/edit/:id",
      icon: "",
      text: "label_essweb_shiftPropertyGroup_form_editTitle",
      bred: "/admin/shift-policy/edit/:id",
    },
  },
  {
    path: "shift-policy/add",
    name: "New Shift Property Group",
    component: newShiftPropertyGroup,
    meta: {
      router: "/admin/shift-policy/add",
      icon: "",
      text: "label_essweb_shiftPropertyGroup_form_newTitle",
      bred: "/admin/shift-policy/add",
    },
  },
  //Shift Type Mapping
  {
    path: "staff-shift-config",
    name: "Shift Type Mapping",
    component: ShiftTypeMapping,
    meta: {
      router: "/admin/staff-shift-config",
      icon: "",
      text: "label_essweb_shiftPropertyGroup_form_viewTitle",
      bred: "/admin/staff-shift-config",
    },
  },
  //Site
  {
    path: "site",
    name: "Site",
    component: Site,
    meta: {
      router: "/admin/site",
      icon: "",
      text: "label_essweb_site_list_title",
      bred: "/admin/site",
    },
  },
  {
    path: "site/add",
    name: "New Site",
    component: newSite,
    meta: {
      router: "/admin/site/add",
      icon: "",
      text: "label_essweb_site_form_newTitle",
      bred: "/admin/site/add",
    },
  },
  {
    path: "site/detail/:id",
    name: "Site Detail",
    component: viewSite,
    meta: {
      router: "/admin/site/detail/:id",
      icon: "",
      text: "label_essweb_site_form_viewTitle",
      bred: "/admin/site/detail/:id",
    },
  },
  {
    path: "site/edit/:id",
    name: "Edit Site Detail",
    component: editSite,
    meta: {
      router: "/admin/site/edit/:id",
      icon: "",
      text: "label_essweb_site_form_editTitle",
      bred: "/admin/site/edit/:id",
    },
  },
  //Site Type
  {
    path: "site-type",
    name: "Site Type",
    component: SiteType,
    meta: {
      router: "/admin/site-type",
      icon: "",
      text: "label_essweb_siteType_list_title",
      bred: "/admin/site-type",
    },
  },
  {
    path: "site-type/add",
    name: "New Site Type",
    component: newSiteType,
    meta: {
      router: "/admin/site-type/add",
      icon: "",
      text: "label_essweb_siteType_form_newTitle",
      bred: "/admin/site-type/add",
    },
  },
  {
    path: "site-type/detail/:id",
    name: "Site Type Detail",
    component: viewSiteType,
    meta: {
      router: "/admin/site-type/detail/:id",
      icon: "",
      text: "label_essweb_siteType_form_viewTitle",
      bred: "/admin/site-type/detail/:id",
    },
  },
  {
    path: "site-type/edit/:id",
    name: "Edit Site Type Detail",
    component: editSiteType,
    meta: {
      router: "/admin/site-type/edit/:id",
      icon: "",
      text: "label_essweb_siteType_form_editTitle",
      bred: "/admin/site-type/edit/:id",
    },
  },
  //Announcement
  {
    path: "company-announcement",
    name: "Admin Announcement",
    component: Announcement,
    meta: {
      router: "/admin/company-announcement",
      icon: "",
      text: "label_essweb_Announcement_list_title",
      bred: "/admin/company-announcement",
    },
  },
  {
    path: "company-announcement/add",
    name: "newannouncement",
    component: newAnnouncement,
    meta: {
      router: "/admin/company-announcement/add",
      icon: "",
      text: "label_essweb_Announcement_form_newTitle",
      bred: "/admin/company-announcement/add",
    },
  },
  {
    path: "company-announcement/detail/:id",
    name: "viewannouncement",
    component: viewAnnouncement,
    meta: {
      router: "/admin/company-announcement/detail/:id",
      icon: "",
      text: "label_essweb_Announcement_form_viewTitle",
      bred: "/admin/company-announcement/detail/:id",
    },
  },
  {
    path: "company-announcement/edit/:id",
    name: "editannouncement",
    component: editAnnouncement,
    meta: {
      router: "/admin/company-announcement/edit/:id",
      icon: "",
      text: "label_essweb_Announcement_form_viewTitle",
      bred: "/admin/company-announcement/edit/:id",
    },
  },
  //Payslip
  {
    path: "company-management/pay-slip",
    name: "payslip",
    component: Payslip,
    meta: {
      router: "/admin/company-management/pay-slip",
      icon: "",
      text: "label_essweb_Payslip_list_title",
      bred: "/admin/company-management/pay-slip",
    },
  },
  //Tax Form
  {
    path: "company-management/tax-form",
    name: "tax",
    component: Tax,
    meta: {
      router: "/admin/company-management/tax-form",
      icon: "",
      text: "label_essweb_Tax_list_title",
      bred: "/admin/company-management/tax-form",
    },
  },
  //CustomForm
  {
    path: "custom-form-type",
    name: "customForm",
    component: CustomForm,
    meta: {
      router: "/admin/custom-form-type",
      icon: "",
      text: "label_essweb_customForm_lsit_title",
      bred: "/admin/custom-form-type",
    },
  },
  {
    path: "custom-form-type/add",
    name: "new customForm",
    component: newCustomForm,
    meta: {
      router: "/admin/custom-form-type/add",
      icon: "",
      text: "label_essweb_customForm_form_newTitle",
      bred: "/admin/custom-form-type/add",
    },
  },
  {
    path: "custom-form-type/detail/:id",
    name: "view customForm",
    component: viewCustomForm,
    meta: {
      router: "/admin/custom-form-type/detail/:id",
      icon: "",
      text: "label_essweb_customForm_form_viewTitle",
      bred: "/admin/custom-form-type/detail/:id",
    },
  },
  {
    path: "custom-form-type/preview/:id",
    name: "preview customForm",
    component: previewCustomForm,
    meta: {
      router: "/admin/custom-form-type/preview/:id",
      icon: "",
      text: "label_essweb_customForm_form_previewTitle",
      bred: "/admin/custom-form-type/preview/:id",
    },
  },
  {
    path: "custom-form-type/edit/:id",
    name: "edit customForm",
    component: editCustomForm,
    meta: {
      router: "/admin/custom-form-type/edit/:id",
      icon: "",
      text: "label_essweb_customForm_form_editTitle",
      bred: "/admin/custom-form-type/edit/:id",
    },
  },
  {
    path: "custom-form-record",
    name: "customFormrecord",
    component: CustomFormRecord,
    meta: {
      router: "/admin/custom-form-record",
      icon: "",
      text: "label_essweb_CustomFormRecord_list_title",
      bred: "/admin/custom-form-record",
    },
  },
  {
    path: "custom-form-record/detail/:params",
    name: "view customFormrecord",
    component: viewCustomFormRecord,
    meta: {
      router: "/admin/custom-form-record/detail/:params",
      icon: "",
      text: "label_essweb_CustomFormRecord_list_viewTitle",
      bred: "/admin/custom-form-record/detail/:params",
    },
  },
  {
    path: "custom-form-record/detail/:params/approval-detail/:args",
    name: "view custom form record Approval Detail",
    component: Status,
    meta: {
      router: "/admin/custom-form-record/detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/admin/custom-form-record/detail/:params/approval-detail/:args",
    },
  },
];
